var _g, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCompliancePdfFile = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 47,
  height: 51,
  viewBox: "0 0 47 51",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#ft1q0l51xa)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.313 1.067h29.989l11.466 11.991v33.638c0 .72-.558 1.304-1.247 1.304H3.313c-.688 0-1.246-.584-1.246-1.304V2.37c0-.72.558-1.303 1.246-1.303z",
  fill: "#F0EFEF"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.794 1.58 45.26 13.574H35.04c-.688 0-1.246-.584-1.246-1.304V1.581z",
  fill: "#D75757"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M29.857 17.013h-13.38A2.676 2.676 0 0 0 13.8 19.69v13.208a2.676 2.676 0 0 0 2.676 2.676h13.38a2.676 2.676 0 0 0 2.677-2.676V19.69a2.676 2.676 0 0 0-2.676-2.676z",
  fill: "#E46464"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M25.154 27.45c-.302-.26-.603-.582-.948-.927a5.555 5.555 0 0 1-.71-1.012c.409-1.4.603-2.734.172-3.38-.194-.302-.495-.453-.883-.453-.43 0-.754.194-.904.56-.345.775.172 2.197.796 3.36-.172.56-.387 1.162-.646 1.83-.15.366-.323.732-.495 1.076-1.766.69-2.842 1.465-2.993 2.197-.065.345.043.646.345.883.172.129.366.215.58.215.087 0 .173-.021.26-.043.818-.215 1.7-1.421 2.346-2.649.388-.15.84-.301 1.336-.43a16.214 16.214 0 0 1 1.55-.388c.84.668 1.55 1.034 2.175 1.034.474.021.818-.151 1.141-.474.474-.474.28-.883.215-.99-.387-.604-1.571-.733-3.337-.41zm-5.642 3.552a.213.213 0 0 1-.172-.021c-.086-.065-.086-.108-.065-.15.043-.26.539-.733 1.615-1.25-.517.775-1.034 1.335-1.378 1.421zm3.058-8.462c.021-.043.043-.108.215-.108.15 0 .215.065.259.108.193.28.172.99-.065 1.938-.366-.819-.56-1.594-.41-1.938zm.603 5.383-.646.194c.064-.15.129-.302.194-.43.15-.41.323-.82.473-1.25.172.237.323.453.474.603.194.216.388.41.581.603-.344.086-.71.172-1.076.28zm4.543.388c-.15.172-.344.237-.581.237-.323 0-.71-.151-1.163-.453 1.249-.172 1.96-.043 1.744.216z",
  fill: "#fff"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "ft1q0l51xa",
  x: 0.067,
  y: 0.067,
  width: 46.701,
  height: 50.933,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.300721 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_230_695"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_230_695",
  result: "shape"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCompliancePdfFile);
export default ForwardRef;